import { Link as RouterLink } from 'react-router-dom'
import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined'
import { APP_LOGO_URL } from '@/lib/branding'
import { ROUTES } from '@/routes/paths'

/**
 * Logo artwork configured per environment through `APP_LOGO` so the same build
 * can point at a different brand image without a code change. When unset, the
 * built-in icon + wordmark lockup below is used as a fallback.
 */
const LOGO_URL = APP_LOGO_URL
const HAS_LOGO = APP_LOGO_URL !== ''

/** Compact AIMS lockup used in the app bar and navigation drawer. */
export function BrandMark({ showText = true }: { showText?: boolean }) {
  const mark = HAS_LOGO ? (
    <Box
      component="img"
      src={LOGO_URL}
      alt="AIMS — DOLE Audit Management"
      sx={{ height: 40, width: 'auto', maxWidth: '100%', display: 'block' }}
    />
  ) : (
    <Stack direction="row" spacing={1.25} sx={{ alignItems: 'center' }}>
      <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: 1.5,
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          display: 'grid',
          placeItems: 'center',
          flexShrink: 0,
        }}
      >
        <AccountBalanceOutlinedIcon fontSize="small" />
      </Box>
      {showText ? (
        <Box sx={{ minWidth: 0, display: { xs: 'none', sm: 'block' } }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 800, lineHeight: 1.1 }}>
            AIMS
          </Typography>
          <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block' }}>
            DOLE Audit Management
          </Typography>
        </Box>
      ) : null}
    </Stack>
  )

  return (
    <Link
      component={RouterLink}
      to={ROUTES.dashboard}
      underline="none"
      color="inherit"
      aria-label="AIMS home"
      // `alignSelf: flex-start` keeps the brand at its natural size when it is a
      // direct child of a column flex parent (e.g. `AuthLayout`'s `Stack`);
      // otherwise it would stretch to full width and clip SVG logos that lack a
      // `viewBox`.
      sx={{ display: 'inline-flex', alignItems: 'center', alignSelf: 'flex-start', minWidth: 0 }}
    >
      {mark}
    </Link>
  )
}
